import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";

interface SettingsState {
  data: any;
  loading: "idle" | "pending" | "fulfilled" | "rejected";
  error: string | null;
  action: "list" | "update" | null;
}

const settingsInitialState: SettingsState = {
  data: null,
  loading: "idle",
  error: null,
  action: null,
};

// 🔹 GET Settings
export const getUpdateSettingAPI: any = createAsyncThunk(
  "settings/get",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.EMPLOYEES.FIND_SETTING, payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

// 🔹 UPDATE Settings
export const updateSettingAPI: any = createAsyncThunk(
  "settings/update",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.EMPLOYEES.UPDATE_SETTING, payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

const settingsSlice = createSlice({
  name: "settings",
  initialState: settingsInitialState,
  reducers: {
    resetSettings: (state) => {
      state.data = null;
      state.loading = "idle";
      state.error = null;
      state.action = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // 📥 GET
      .addCase(getUpdateSettingAPI.pending, (state) => {
        state.loading = "pending";
        state.data = null;
        state.error = null;
        state.action = "list";
      })
      .addCase(getUpdateSettingAPI.fulfilled, (state, action) => {
        state.loading = "fulfilled";
        state.data = action.payload;
        state.error = null;
        state.action = "list";
      })
      .addCase(getUpdateSettingAPI.rejected, (state, action) => {
        state.loading = "rejected";
        state.error = action.payload as string;
        state.data = null;
        state.action = "list";
      })

      // 🛠 UPDATE
      .addCase(updateSettingAPI.pending, (state) => {
        state.loading = "pending";
        state.error = null;
        state.action = "update";
      })
      .addCase(updateSettingAPI.fulfilled, (state, action) => {
        state.loading = "fulfilled";
        state.data = action.payload;
        state.error = null;
        state.action = "update";
      })
      .addCase(updateSettingAPI.rejected, (state, action) => {
        state.loading = "rejected";
        state.error = action.payload as string;
        state.action = "update";
      });
  },
});

export const { resetSettings } = settingsSlice.actions;
export default settingsSlice.reducer;
